module.exports = __webpack_public_path__ + "9779d9a1/img/upload-icon.9179ae4e.svg";